/**
 * @author: Pawan Singh Sisodiya
 */
import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import schoolApi from "../../api/schoolApi";
import { useReactToPrint } from "react-to-print";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InstallmentTable from "./InstallmentTable";
import FeeReceipt from "./FeeReceipt";
import moment from "moment";
import html2pdf from "html2pdf.js";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
const parseSafe = (val) => {
  if (typeof val === "string") return parseInt(val.replace(/,/g, "")) || 0;
  return parseInt(val) || 0;
};
function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
const FeeDepositeEdit = (props) => {
  const getCurrentDate = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  const formatDateForPayload = (date) => {
    if (!date) {
      return "";
    }

    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);

    const day = String(normalizedDate.getDate()).padStart(2, "0");
    const month = String(normalizedDate.getMonth() + 1).padStart(2, "0");
    const year = normalizedDate.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const calculateInstallmentLateFee = (
    installment,
    paymentDate,
    frequencySettings,
    lateFeeSettings,
    isRte
  ) => {
    if (installment?.status !== "pending" || isRte) {
      return installment?.late_fee || 0;
    }

    const referenceDate = paymentDate ? new Date(paymentDate) : getCurrentDate();
    referenceDate.setHours(0, 0, 0, 0);

    const dueDate = installment?.due_date ? new Date(installment.due_date) : null;
    if (!dueDate || Number.isNaN(dueDate.getTime())) {
      return 0;
    }

    dueDate.setHours(0, 0, 0, 0);

    if (dueDate >= referenceDate) {
      return 0;
    }

    const differenceInDays = Math.ceil(
      (referenceDate - dueDate) / (1000 * 3600 * 24)
    );
    const frequency = parseInt(frequencySettings, 10) || 1;
    const lateFee = parseInt(lateFeeSettings, 10) || 0;
    const netDueDays = parseInt((differenceInDays + frequency) / frequency, 10);

    return Math.round(netDueDays * lateFee);
  };

  const normalizeInstallmentsForPaymentDate = (
    installments,
    paymentDate,
    frequencySettings,
    lateFeeSettings
  ) => {
    if (!Array.isArray(installments)) {
      return [];
    }

    const normalizedInstallments = installments.map((item) => ({
      ...item,
      late_fee_paid: parseSafe(item.late_fee_paid || 0), // Preserve DB value (paid so far)
      late_fee: calculateInstallmentLateFee(
        item,
        paymentDate,
        frequencySettings,
        lateFeeSettings,
        studentRecord?.isrte
      ),
    }));

    return normalizedInstallments.map((item) => {
      if (item.deposit_id && item.late_fee > 0) {
        const lateFeeHelper = normalizedInstallments.filter(
          (ft) => ft.deposit_id === item.deposit_id
        );

        if (item.id !== lateFeeHelper[lateFeeHelper.length - 1]?.id) {
          return { ...item, late_fee: 0 };
        }
      }

      return item;
    });
  };

  const [selectedReceiptData, setSelectedReceiptData] = useState(null);
  const [isReceiptReady, setIsReceiptReady] = useState(false);
  const receiptRef = useRef();
  const location = useLocation();
  const [readOnly, setReadOnly] = useState(location?.state?.readonly ? location?.state?.readonly : false);
  const [studentRecord, SetStudentRecord] = useState(
    location?.state?.row?.student_info ? location?.state?.row?.student_info : {}
  );
  const [studentInstallment, setStudentInstallment] = useState();
  const [baseInstallments, setBaseInstallments] = useState([]);
  const [lateFeeConfig, setLateFeeConfig] = useState({
    frequencySettings: 0,
    lateFeeSettings: 0,
  });
  const [feeDeposit, setFeeDeposit] = useState({});
  const [disablebutton, setdisablebutton] = useState(false);
  const [tempAmount, setTempAmount] = useState({});
  const [showTransaction, setShowTransaction] = useState(true);
  const [isDiscountEditable, setIsDiscountEditable] = useState(false);
  let [reportData, setReportData] = useState({ payment_date: getCurrentDate() });
  const navigate = useNavigate();
  const handleDateChange = (date, name) => {
    const selectedDate = date ? new Date(date) : null;
    if (selectedDate) {
      selectedDate.setHours(0, 0, 0, 0);
    }

    if (date) {
      setReportData((prevState) => ({
        ...prevState,
        [name]: selectedDate,
      }));
      setFeeDeposit((prev) => {
        return { ...prev, [name]: formatDateForPayload(selectedDate) };
      });
    } else {
      setReportData((prevState) => ({
        ...prevState,
        [name]: "",
      }));
      setFeeDeposit((prev) => {
        return { ...prev, [name]: "" };
      });
    }
  };

  useEffect(() => {
    const rowData = location?.state?.row;
    if (rowData) {
      const studentData = rowData.student_info || rowData;


      if (studentData.studentname) {
        SetStudentRecord(studentData);
        sessionStorage.setItem(
          "temp",
          JSON.stringify(rowData.student_info || rowData)
        );
      } else {
        const tempData = JSON.parse(sessionStorage.getItem("temp"));
        if (tempData) {
          SetStudentRecord(tempData);
        }
      }
    }
  }, [location.state.row]);
  useEffect(() => {
    initClass();
  }, [studentRecord]);

  useEffect(() => {
    if (!baseInstallments.length) {
      return;
    }

    let normalizedInstallments = normalizeInstallmentsForPaymentDate(
      baseInstallments,
      reportData.payment_date,
      lateFeeConfig.frequencySettings,
      lateFeeConfig.lateFeeSettings
    );

    if (studentInstallment && studentInstallment.length > 0) {
      normalizedInstallments = normalizedInstallments.map(item => {
        const existing = studentInstallment.find(si => si.id === item.id);
        return {
          ...item,
          isCheked: existing ? existing.isCheked : item.isCheked
        };
      });
    }

    if (studentRecord?.edit) {
      const editableInstallments = normalizedInstallments.map((res) => {
        if (res.deposit_id === studentRecord.deposit_id) {
          return { ...res, edit: true };
        }

        return { ...res, edit: false };
      });

      setStudentInstallment(editableInstallments);
      feeDepositHandler(
        editableInstallments.filter((item) => item.edit && item.status === "completed")
      );
      return;
    }

    setStudentInstallment(normalizedInstallments);
    const checkedInstallments = normalizedInstallments.filter((item) => item.isCheked);
    if (checkedInstallments.length) {
      feeDepositHandler(checkedInstallments);
    }
  }, [
    baseInstallments,
    reportData.payment_date,
    studentRecord?.deposit_id,
    lateFeeConfig.frequencySettings,
    lateFeeConfig.lateFeeSettings,
  ]);


  async function initClass() {
    try {
      setdisablebutton(false);

      let frequencySettings = 0;
      let lateFeeSettings = 0;
      const ResultSettings = await schoolApi.getAllSetting();
      if (ResultSettings.success) {
        frequencySettings = ResultSettings?.data?.filter(
          (res) => res.key === "frequency"
        )[0].value;
        lateFeeSettings = ResultSettings?.data?.filter(
          (res) => res.key === "late_fee"
        )[0].value;
      }
      const insResult = await schoolApi.getallIntsallment(
        studentRecord?.student_addmission_id,
        studentRecord?.session_id
          ? studentRecord?.session_id
          : studentRecord?.sessionid,
        readOnly ? studentRecord?.fee_master_installment_id : undefined
      );

      const paymentDateForCalculation = studentRecord?.payment_date
        ? moment(studentRecord.payment_date, "DD-MM-YYYY").toDate()
        : reportData.payment_date || getCurrentDate();

      const normalizedInstallments = normalizeInstallmentsForPaymentDate(
        insResult?.result || [],
        paymentDateForCalculation,
        frequencySettings,
        lateFeeSettings
      );

      if (studentRecord?.edit) {
        const editableInstallments = normalizedInstallments.map((res) => {
          if (res.deposit_id === studentRecord.deposit_id) {
            return { ...res, edit: true };
          } else {
            return { ...res, edit: false };
          }
        });
        setBaseInstallments(editableInstallments);
      } else {
        setBaseInstallments(normalizedInstallments);
      }

      if (insResult.success) {
        setLateFeeConfig({
          frequencySettings,
          lateFeeSettings,
        });
        setReportData((prevState) => ({
          ...prevState,
          payment_date: paymentDateForCalculation,
        }));
      }
    } catch (error) { }
  }

  const handleCloseModal = () => {
    setFeeDeposit({});
    setdisablebutton(false);
    setTempAmount({});
  };

  const feeDepositHandler = (installments) => {
    const totals = {
      totalAmount: 0,
      discount: 0,
      previous_due: 0,
      due_amount: 0,
      totalTransportFee: 0,
      grossPayableAmount: 0,
      late_fee: 0,
      netPayableAmount: 0,
      amount: 0,
      payment_date: new Date(),
      payment_method: "Cash",
      receipt_number: "",
      late_joinee_discount: 0,
      deposited_amount: 0,
      installments: [],
      deposit_id: null,
    };

    const hasOthersDiscount = installments?.some((res) =>
      res.discounts?.some((d) => d.name === "Others" || d.name === "Other")
    );
    setIsDiscountEditable(hasOthersDiscount);

    const parseAmount = parseSafe;

    installments?.forEach((res, index) => {
      const transportFee = parseAmount(res?.transport_fee);
      const installmentAmt = parseAmount(res?.installment_amount);
      const installmentDiscount = parseAmount(res?.installment_discount);
      const previousDue = parseAmount(res?.previous_due);
      const lateFee = res?.late_fee ? res?.late_fee : 0;

      const itemDiscount = res?.discounted_amount !== undefined ? parseAmount(res.discounted_amount) : installmentDiscount;
      const itemGross = res?.grossPayableAmount !== undefined ? parseAmount(res.grossPayableAmount) : (installmentAmt + transportFee - itemDiscount);
      const itemNet = res?.net_payable_amount !== undefined ? parseAmount(res.net_payable_amount) : (itemGross + previousDue + lateFee);

      totals.installments.push({ 
        id: res?.id,
        late_fee: lateFee,
        pushed_late_fee: res?.pushed_late_fee,
        late_fee_paid: res?.late_fee_paid,
        deposited_amount: res?.deposited_amount,
        month: res?.month,
        transport_fee: res?.transport_fee,
        transport_fee_paid: res?.transport_fee_paid
      });
      totals.late_joinee_discount = parseAmount(res?.late_joinee_discount);
      totals.totalAmount += installmentAmt + transportFee;
      totals.discount += itemDiscount;
      totals.previous_due += previousDue;
      totals.totalTransportFee += transportFee;
      totals.grossPayableAmount += itemGross;
      totals.netPayableAmount += itemNet;
      const totalLateFeeLiability = parseSafe(res.pushed_late_fee || 0) > 0 
        ? parseSafe(res.pushed_late_fee || 0) 
        : parseSafe(res.late_fee || 0);
      const remainingLateFee = Math.max(0, totalLateFeeLiability - parseSafe(res.late_fee_paid || 0));

      totals.late_fee += remainingLateFee;
      totals.deposited_amount += parseAmount(res?.deposited_amount);
    });

    const parseValue = (val) => {
      if (typeof val === "string") {
        return parseInt(val.replace(/,/g, "")) || 0;
      }
      return parseInt(val) || 0;
    };

    // Match Receipt Logic: Net = (Heads) + PreviousDue + LateFee - ManualDiscount
    const currentDiscount = parseValue(
      isDiscountEditable && feeDeposit?.discount !== undefined
        ? feeDeposit.discount
        : totals.discount
    );

    const netPayable =
      totals.totalAmount +
      (studentRecord?.previous_due || totals.previous_due || 0) +
      totals.late_fee -
      currentDiscount -
      totals.deposited_amount;

    // If the netPayable has changed from what was originally saved, we might need a new amount
    const amountPaid = parseValue(
      feeDeposit?.amount !== undefined
        ? feeDeposit.amount
        : studentRecord?.amount || netPayable
    );

    let dueAmt = netPayable - amountPaid;
    if (dueAmt < 0) dueAmt = 0;

    const finalTotals = {
      ...totals,
      discount: currentDiscount,
      netPayableAmount: netPayable,
      due_amount: Math.round(dueAmt),
      amount: amountPaid,
      previous_due: studentRecord?.previous_due || totals.previous_due || 0,
      grossPayableAmount: totals.totalAmount - currentDiscount,
    };

    setFeeDeposit(finalTotals);
    setTempAmount(finalTotals);
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.name === "amount") {
      if (isNaN(e.target.value)) {
        return;
      }


      const enteredValue = e.target.value;

      if (enteredValue != "" && enteredValue <= feeDeposit?.netPayableAmount) {
        const amt = feeDeposit?.netPayableAmount;
        const dueAmount = amt - enteredValue;

        setFeeDeposit({
          ...feeDeposit,
          [e.target.name]: enteredValue,
          due_amount: Math.round(dueAmount),
        });
      } else if (
        enteredValue == "" &&
        enteredValue <= feeDeposit?.netPayableAmount
      ) {
        setFeeDeposit({
          ...feeDeposit,
          [e.target.name]: "0",
          due_amount: feeDeposit?.netPayableAmount,
        });
      } else {
        toast.error("Entered amount exceeds total amount!");
      }
    } else if (e.target.name === "late_fee") {

      if (e.target.value > 100000000) {
        return toast.error("Enter valid late fee");
      }

      if (isNaN(e.target.value) || e.target.value === "") {
        e.target.value = 0;
      }

      let late = e.target.value;
      let amt = feeDeposit?.amount;
      let ntp = feeDeposit?.netPayableAmount;
      let dueAmount = 0;

      console.log("feeDeposit?.netPayableAmount ->", feeDeposit?.netPayableAmount);
      console.log("tempAmount?.netPayableAmount ->", tempAmount?.netPayableAmount);
      console.log("feeDeposit?.amount ->", feeDeposit?.amount);
      console.log("tempAmount?.amount ->", tempAmount?.amount);
      console.log("feeDeposit?.late_fee ->", feeDeposit?.late_fee);
      console.log("tempAmount?.late_fee ->", tempAmount?.late_fee);

      console.log("late ->", late);

      if (late !== "") {
        console.log("hadsfi");
        //700-15800+1580
        if (parseInt(feeDeposit?.netPayableAmount) >= parseInt(feeDeposit?.late_fee)) {
          ntp =
            (parseInt(feeDeposit?.netPayableAmount) -
              parseInt(feeDeposit?.late_fee)) +
            parseInt(late);
          amt = ntp;

          dueAmount = ntp - amt;
        } else {
          ntp =
            (parseInt(feeDeposit?.netPayableAmount)) +
            parseInt(late);
          amt = ntp;

          dueAmount = ntp - amt;
        }

      } else {
        console.log("hadspanakfi");

        amt = parseInt(feeDeposit?.amount) - 0;
        ntp =
          parseInt(feeDeposit?.netPayableAmount) -
          parseInt(feeDeposit?.late_fee);

        dueAmount = 0;
      }
      console.log("dueAmount->", dueAmount);
      console.log("amt->", amt);
      console.log("late->", late);
      console.log("amt->", amt);


      setFeeDeposit({
        ...feeDeposit,
        [e.target.name]: parseInt(late),
        amount: amt,
        netPayableAmount: ntp,
        due_amount: Math.round(dueAmount),
      });

    } else if (e.target.name === "payment_method") {
      if (e.target.value !== "Cash") {
        setShowTransaction(false);
      } else {
        setShowTransaction(true);
      }
      setFeeDeposit({ ...feeDeposit, [e.target.name]: e.target.value });
    } else if (e.target.name === "receipt_number") {
      const numericValue = e.target.value.replace(/\D/g, "");
      setFeeDeposit({ ...feeDeposit, [e.target.name]: numericValue });
    } else if (e.target.name === "discount") {
      const disc = parseInt(e.target.value) || 0;
      const totalAmt = parseSafe(feeDeposit?.totalAmount || 0);
      const prevDue = parseSafe(feeDeposit?.previous_due || 0);
      const lateFee = parseSafe(feeDeposit?.late_fee || 0);
      const deposited = parseSafe(feeDeposit?.deposited_amount || 0);

      const newGross = totalAmt - disc;
      const newNetRecord = newGross + prevDue + lateFee - deposited;
      
      const newAmount = feeDeposit?.amount || 0;
      const newDueRecord = newNetRecord - newAmount;

      setFeeDeposit({
        ...feeDeposit,
        discount: disc,
        grossPayableAmount: newGross,
        netPayableAmount: newNetRecord,
        due_amount: newDueRecord > 0 ? Math.round(newDueRecord) : 0,
      });
    } else {
      setFeeDeposit({ ...feeDeposit, [e.target.name]: e.target.value });
    }
  };

  const amountManager = () => {
    if (feeDeposit.amount <= 0) {
      feeDeposit.amount = feeDeposit.netPayableAmount;
    }
  };

  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    documentTitle: "FeeReceipt",
    onAfterPrint: () => {
      setIsReceiptReady(false);
      setSelectedReceiptData(null);
      if (studentRecord.edit) {
        navigate("/feedepositehistory/e", {
          state: { row: { student_info: location.state.row } },
        });
      } else {
        navigate(0);
      }
    },
  });

  const saveAsPdf = async (data) => {
    const element = receiptRef.current;
    const options = {
      margin: 0,
      filename: "FeeReceipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    };

    const pdfBlob = await html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .output("blob");
    const formData = new FormData();
    formData.append("file", pdfBlob, "FeeReceipt.pdf");

    const result = await schoolApi.createFile(data.deposit_id, formData);
  };

  const handlePrintClick = async (data) => {
    try {
      setIsReceiptReady(false);
      setSelectedReceiptData(data);
    } catch (error) { }
  };

  useEffect(() => {
    if (selectedReceiptData && isReceiptReady) {
      handlePrint();
    }
  }, [selectedReceiptData, isReceiptReady, handlePrint]);

  async function payonline() {
    const amount = feeDeposit?.amount
      ? feeDeposit?.amount
      : feeDeposit?.netPayableAmount
        ? feeDeposit?.netPayableAmount
        : 0;
    try {
      if (amount > 0) {
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );
        if (!res) {
          alert("Razorpay failed to load!!");
          return;
        }

        const data = await schoolApi.FeeDepositOnline(amount);

        const options = {
          key: "rzp_test_yDpYkhztZpWoC5",
          amount: amount * 100,
          currency: "INR",
          name: "Acme Corp",
          description: "Test Transaction",
          image: "https://example.com/your_logo",
          order_id: data.result.id,
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#3399cc",
          },
          handler: async function (response) {
            try {
              const paymentData = {
                order_id: response.order_id,
                payment_id: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                student_addmission_id: studentRecord?.student_addmission_id,
                amount: amount,
                payment_date: new Date(),
                payment_method: "Online (Razorpay)",
                transaction_no: response.razorpay_payment_id,
                status: "Success",
              };
              if (response.razorpay_payment_id) {
                feeDeposit.payment_method = "razorpay";
                feeDeposit.transaction_no = response.razorpay_payment_id;
                handleSaveDeposites();
              } else {
                toast.error("payment not acctepable");
              }
            } catch (error) {
              toast.error("Something went wrong while saving payment.");
            }
          },
          prefill: {
            name: feeDeposit?.student_name,
            email: feeDeposit?.student_email,
            contact: feeDeposit?.student_contact,
          },
          modal: {
            ondismiss: function () { },
          },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        toast.error("Enter amount gerterthan zero");
      }
    } catch (error) { }
  }

  const handleSaveDeposites = async () => {
    try {
      if (
        feeDeposit.amount === null ||
        feeDeposit.amount === undefined ||
        feeDeposit.amount === "" ||
        !feeDeposit.payment_date ||
        !feeDeposit.payment_method
      ) {
        return toast.error("Missing requirwed fields!!");
      }
      if (!feeDeposit?.receipt_number) {
        return toast.error("Receipt number is required");
      }


      const finalAmount =
        feeDeposit.amount === 0 ||
          feeDeposit.amount === "0" ||
          !feeDeposit.amount
          ? feeDeposit.netPayableAmount
          : feeDeposit.amount;

      const finalDue = Math.max(
        0,
        Math.round(feeDeposit.netPayableAmount - finalAmount)
      );

      feeDeposit.amount = finalAmount;
      feeDeposit.due_amount = finalDue;

      // if (feeDeposit.payment_method !== "Cash" && !feeDeposit?.transaction_no) {
      //   return toast.error("Missing required fields!!");
      // }
      if (feeDeposit.amount > feeDeposit.netPayableAmount) {
        return toast.error("Amount is greater then net payable amount");
      }


      // Distribute the manual late fee total across installments to avoid ghost balance
      const totalManualLateFee = parseSafe(feeDeposit?.late_fee || 0);
      const updatedInstallments = [...(feeDeposit?.installments || [])];
      
      if (updatedInstallments.length > 0) {
        // Calculate the sum of REMAINING late fees currently in the installments list (Charged - Already Paid)
        const currentRemainingSum = updatedInstallments.reduce((acc, inst) => {
          const liability = parseSafe(inst.pushed_late_fee || inst.late_fee || 0);
          const alreadyPaid = parseSafe(inst.late_fee_paid || 0);
          return acc + Math.max(0, liability - alreadyPaid);
        }, 0);

        // If user manually changed the total late fee in the footer
        if (totalManualLateFee !== currentRemainingSum) {
          const diff = totalManualLateFee - currentRemainingSum;
          const lastIdx = updatedInstallments.length - 1;
          
          // Adjust the last installment's total liability by the difference
          const lastInstTotalLiability = parseSafe(updatedInstallments[lastIdx].pushed_late_fee || updatedInstallments[lastIdx].late_fee || 0);
          updatedInstallments[lastIdx].pushed_late_fee = Math.max(0, lastInstTotalLiability + diff);
        }
      }

      const arr = {
        totalAmount: feeDeposit?.totalAmount,
        netPayableAmount: feeDeposit?.netPayableAmount,
        student_addmission_id: studentRecord?.student_addmission_id,
        student_id: studentRecord.student_id || studentRecord.id,
        discount: feeDeposit?.discount,
        installments: updatedInstallments, // Use the synced installments
        amount: feeDeposit?.amount
          ? feeDeposit?.amount
          : feeDeposit.netPayableAmount, // updated
        late_joinee_discount: feeDeposit?.late_joinee_discount,
        sessionid: studentRecord?.session_id,
        payment_date: feeDeposit?.payment_date,
        payment_method: feeDeposit?.payment_method,
        receipt_number: feeDeposit?.receipt_number,
        late_fee: totalManualLateFee,
        remark: feeDeposit?.remark,
        due_amount: feeDeposit?.due_amount,
        transaction_no: feeDeposit?.transaction_no,
        isManualDiscount: isDiscountEditable,
      };


      if (studentRecord.edit) {
        setdisablebutton(true);
        const feeDepositEditResult = await schoolApi.updateFeeDepositsById(
          studentRecord?.deposit_id,
          arr
        );

        if (feeDepositEditResult) {
          arr.deposit_id = feeDepositEditResult.result.newFeeDeposite.id;

          toast.success("Fees deposite Updated successfully!!");
          await handlePrintClick(arr);
        } else {
        }
      } else {
        setdisablebutton(true);
        if (arr) {
          const feeDepositResult = await schoolApi.createFeeDeposit(arr);

          if (feeDepositResult) {
            arr.deposit_id = feeDepositResult.deposit.id;
            toast.success("Fees deposited successfully!!");
            await handlePrintClick(arr);
          } else {
          }
        }
      }
    } catch (error) {
      setdisablebutton(false);
    }
  };

  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };
  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={2} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Fee Deposit Create
          </Link>
        </Col>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <Row className="view-form">
          <Row className="section-header my-2">
            <Col lg={9}>
              <span>Fee Deposit Edit</span>
            </Col>
            <Col lg={2} className="d-flex justify-content-end"></Col>
          </Row>
          <Row
            className="mx-3"
            style={{ backgroundColor: "white", borderRadius: "10px" }}
          >
            <Row className="pb-3">
              <Col lg={1}></Col>
              <Col lg={5}>
                <label>Student Name</label>
                <span>{studentRecord?.studentname}</span>
              </Col>
              <Col lg={5}>
                <label>Email</label>
                <span>{studentRecord?.email}</span>
              </Col>
              <Col lg={1}></Col>
              <Col lg={1}></Col>
              <Col lg={5}>
                <label>Dob</label>
                <span>
                  {moment(studentRecord.dateofbirth).format("DD-MM-YYYY")}
                </span>
              </Col>
              <Col lg={5}>
                <label>Category</label>
                <span>{studentRecord?.category}</span>
              </Col>

              <Col lg={1}></Col>
              <Col lg={1}></Col>
              <Col lg={5}>
                <label>Phone</label>
                <span>{studentRecord?.phone}</span>
              </Col>
              <Col lg={5}>
                <label>Total Fees (₹)</label>
                <span>
                  {formatNumberWithCommas(parseInt(studentRecord?.total_fees))}
                </span>
              </Col>

              <Col lg={1}></Col>
              <Col lg={1}></Col>
              <Col lg={1}></Col>

              <Col></Col>
            </Row>
          </Row>
          <Col lg={2}></Col>
        </Row>

        {studentInstallment && (
          <InstallmentTable
            data={studentInstallment}
            edit={studentRecord?.edit}
            feeDepositHandler={feeDepositHandler}
            feeDeposit={feeDeposit}
            studentRecord={studentRecord}
          />
        )}

        {feeDeposit?.totalAmount > 0 && (
          <>
            <Row>
              <Col lg={1}></Col>
              <Col lg={5} className="mb-3">
                <Row>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Total Amount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="totalAmount"
                      placeholder="Enter Duration"
                      value={feeDeposit?.totalAmount}
                      onChange={(e) => handleChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Row>
                {feeDeposit?.late_joinee_discount > 0 && (
                  <Row>
                    <Form.Group className="mt-3 mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Late Joinee Discount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={feeDeposit?.late_joinee_discount}
                        name="late_joinee_discount"
                        placeholder="0"
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Row>
                )}

                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicReceiptNumber"
                    >
                      Receipt Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={feeDeposit?.receipt_number || ""}
                      name="receipt_number"
                      placeholder="Enter Receipt Number"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Discount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      disabled={!isDiscountEditable}
                      value={feeDeposit?.discount}
                      name="discount"
                      placeholder="Enter Discount"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Gross Payable
                    </Form.Label>
                    <Form.Control
                      type="number"
                      disabled
                      value={feeDeposit?.grossPayableAmount}
                      name="gross_payable"
                      placeholder="Enter Discount"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className=" mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Prevoius Dues
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="previous_due"
                      placeholder="Total Dues"
                      value={feeDeposit?.previous_due}
                      onChange={(e) => handleChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Late Fee
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={feeDeposit?.late_fee}
                      name="late_fee"
                      placeholder="Enter Late Fee"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Net Payable Amount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="net_payable_amount"
                      placeholder="Net Payable Amount"
                      value={feeDeposit?.netPayableAmount}
                      onChange={(e) => handleChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Row>
              </Col>
              <Col lg={5}>
                <Row>
                  <Form.Group className=" mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Enter Amount
                    </Form.Label>
                    <Form.Control
                      required
                      type="numeric"
                      inputMode="numeric"
                      value={
                        feeDeposit?.amount
                          ? feeDeposit?.amount
                          : feeDeposit?.netPayableAmount
                            ? feeDeposit?.netPayableAmount
                            : 0
                      }
                      name="amount"
                      placeholder="Enter Deposite Amount"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Due Amount
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      value={feeDeposit?.due_amount}
                      name="due_amount"
                      placeholder="Enter Due Amount"
                      onChange={(e) => handleChange(e, null, null)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicLastName"
                    >
                      Deposite Date
                    </Form.Label>
                    <DatePicker
                      required
                      selected={reportData.payment_date}
                      onChange={(date) =>
                        handleDateChange(date, "payment_date")
                      }
                      dateFormat="dd-MM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select a date"
                      className="form-control"
                      style={{ width: "300px" }}
                      onKeyDown={(e) => e.preventDefault()}
                      highlightDates={[new Date()]}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicClass"
                    >
                      Payment Method
                    </Form.Label>
                    <Form.Select
                      required
                      name="payment_method"
                      value={feeDeposit?.payment_method}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="" disabled>
                        -- Select Type --
                      </option>
                      <option value="Cash">Cash</option>
                      <option value="NEFT">NEFT</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Paytm">Paytm</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Transaction Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={feeDeposit?.transaction_no}
                      name="transaction_no"
                      placeholder="Enter Transaction No"
                      // required={
                      //   feeDeposit?.payment_method &&
                      //   feeDeposit?.payment_method !== "Cash"
                      // }
                      onChange={(e) => handleChange(e)}
                      disabled={showTransaction && !feeDeposit?.transaction_no}
                    />
                  </Form.Group>
                </Row>
                <Row className="mt-3 ms-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Remark
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      value={feeDeposit?.remark}
                      name="remark"
                      placeholder="Enter Remark"
                      onChange={(e) => handleChange(e, null, null)}
                    />
                  </Form.Group>
                </Row>
              </Col>
              <Col lg={1}></Col>
            </Row>
            <Row className={"justify-content-center"}>
              <Col lg={3}>
                <Button
                  className="mx-3 mt-3 mb-3"
                  variant="secondary"
                  onClick={handleCloseModal}
                  disabled={disablebutton}
                >
                  Close
                </Button>
                <Button
                  className="mx-3 mt-3 mb-3"
                  variant="primary"
                  onClick={handleSaveDeposites}
                  disabled={disablebutton}
                >
                  Save
                </Button>

                <Button
                  className="mx-3 mt-3 mb-3"
                  backgroundColor="#e8ad2e"

                  onClick={payonline}
                  disabled={disablebutton}
                >
                  Pay Online
                </Button>
              </Col>
            </Row>
            {selectedReceiptData && (
              <div style={{ display: "none" }}>
                <FeeReceipt
                  ref={receiptRef}
                  receiptData={selectedReceiptData}
                  onReady={() => setIsReceiptReady(true)}
                />
              </div>
            )}
          </>
        )}
      </Row>
    </>
  );
};

export default FeeDepositeEdit;
